import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import { RecipientSummary } from "./types";
import { CampaignChannel } from "./types";

interface PreviewCardProps {
  data: RecipientSummary | null;
  channel: CampaignChannel;
  loading: boolean;
  onRunCheck: () => void;
}

export default function PreviewCard({
  data,
  channel,
  loading,
  onRunCheck,
}: PreviewCardProps) {
  return (
    <div className="card">
      <div className="card-title">Preview</div>

      <div className="campaign-preview-toolbar">
        <span className="field-hint">
          {data
            ? "Recipient check complete"
            : "Check which recipients can receive this campaign"}
        </span>
        <button
          type="button"
          className="action-button secondary compact campaign-preview-check"
          onClick={onRunCheck}
          disabled={loading}
        >
          <FactCheckOutlinedIcon fontSize="inherit" aria-hidden="true" />
          {loading ? "Checking…" : data ? "Check again" : "Check recipients"}
        </button>
      </div>

      {data && (
        <div className="campaign-preview-summary" aria-live="polite">
          <span><strong>{data.readyToSend}</strong> ready to send</span>
          <span><strong>{data.missingMobile}</strong> missing mobile</span>
          <span>
            <strong>{data.optedOut}</strong>{" "}
            {channel === "WHATSAPP" ? "without WhatsApp consent" : "opted out"}
          </span>
          <span><strong>{data.duplicates}</strong> duplicates</span>
        </div>
      )}
    </div>
  );
}
